import React, {useEffect, useState} from "react";

export enum UserFormMode {
    ADD = "add",
    EDIT = "edit",
}

interface UserFormProps {
    mode: UserFormMode;
    initialValues: {
        accountName: string;
        userName: string;
        password: string;
        phoneNumber: string | null;
        role: string;
        uc?: string;
        pairWorkingPointStore?: string;
        selectedWorkingPointId?: string;
    };
    availableRoles: string[];
    warehouses: any;
    workingPoints: any[];
    onSubmit: (data: any) => void;
}

const UserFormPage: React.FC<UserFormProps> = ({
                                                   mode,
                                                   initialValues,
                                                   availableRoles,
                                                   warehouses,
                                                   workingPoints,
                                                   onSubmit,
                                               }) => {
    const [accountName, setAccountName] = useState(initialValues.accountName);
    const [userName, setUserName] = useState(initialValues.userName);
    const [password, setPassword] = useState(initialValues.password);
    const [phoneNumber, setPhoneNumber] = useState(initialValues.phoneNumber);
    const [role, setRole] = useState(initialValues.role);
    const [uc, setUC] = useState(initialValues.uc);
    const [pairWorkingPointStore, setPairWorkingPointStore] = useState<string | undefined>(initialValues.pairWorkingPointStore);
    const [selectedWorkingPointId, setSelectedWorkingPointId] = useState<string | undefined>(initialValues.selectedWorkingPointId);

    const handleSubmit = () => {
        onSubmit({
            accountName,
            userName,
            password,
            phoneNumber,
            role,
            uc,
            pairWorkingPointStore,
            selectedWorkingPointId,
        });
    };

    useEffect(() => {
        if (role === "BASICSUPPORT" || role === "SUPERBASIC") {
            setUC("816");
        } else if (role === "B2BSUPPORT") {
            setUC("817");
        }
    }, [role]);

    useEffect(() => {
        const wp = workingPoints.find((wp) => wp.id === selectedWorkingPointId);
        if (wp) {
            setAccountName(wp.organization.contactEmail || "");
            setUserName(wp.organization.contactPerson || "");
            setPhoneNumber(wp.organization.contactPhone || "");
        }
    }, [selectedWorkingPointId, workingPoints, role]);

    return (
        <div className="flex flex-row">
            <div className="w-full px-8 py-4">
                <div className="grid gap-y-4 w-1/3">

                    {mode === UserFormMode.ADD && <label className="flex justify-between items-center w-full">
                        <span className="text-lg font-medium text-gray-700 mt-2 mr-16">Nume Utilizator</span>
                        <input
                            type="text"
                            name="fullName"
                            autoComplete="off"
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                            className="bg-gray-100 rounded py-2 px-1.5 border-gray-300 border-2 shadow-sm sm:text-sm pl-2"
                        />
                    </label>}

                    {mode === UserFormMode.ADD && <label className="flex justify-between items-center w-full">
                        <span className="text-lg font-medium text-gray-700 mt-2 mr-16">Email Utilizator</span>
                        <input
                            type="email"
                            name="email"
                            autoComplete="off"
                            value={accountName}
                            onChange={(e) => setAccountName(e.target.value)}
                            className="bg-gray-100 rounded py-2 px-1.5 border-gray-300 border-2 shadow-sm sm:text-sm pl-2"
                        />
                    </label>}

                    {mode === UserFormMode.ADD && <label className="flex justify-between items-center w-full">
                        <span className="text-lg font-medium text-gray-700 mt-2 mr-16">Parola</span>
                        <input
                            type="password"
                            value={password}
                            autoComplete="off"
                            onChange={(e) => setPassword(e.target.value)}
                            className="bg-gray-100 rounded py-2 px-1.5 border-gray-300 border-2 shadow-sm sm:text-sm pl-2"
                        />
                    </label>}

                    {mode === UserFormMode.ADD && <label className="flex justify-between items-center w-full">
                        <span className="text-lg font-medium text-gray-700 mt-2 mr-16">Nr Telefon</span>
                        <input
                            type="text"
                            value={phoneNumber ? phoneNumber : ""}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            className="bg-gray-100 rounded py-2 px-1.5 border-gray-300 border-2 shadow-sm sm:text-sm pl-2"
                        />
                    </label>}
                    
                    <label className="flex justify-between items-center w-full">
                        <span className="text-lg font-medium text-gray-700 mt-2 mr-16">Rol</span>
                        <select
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                            className="bg-gray-100 rounded py-2 px-1.5 border-gray-300 border-2 shadow-sm sm:text-sm pl-2"
                        >
                            <option value="" disabled>Selectează un rol</option>
                            {availableRoles.map((role) => (
                                <option key={role} value={role}>{role}</option>
                            ))}
                        </select>
                    </label>
                    
                    {role === "AUCHANMBAEMPLOYEE" && (
                        <label className="flex justify-between items-center w-full">
                            <span className="text-lg font-medium text-gray-700 mt-2 mr-16">Magazin MBA Alocat</span>
                            <select
                                value={pairWorkingPointStore}
                                onChange={(e) => setPairWorkingPointStore(e.target.value)}
                                className="bg-gray-100 rounded py-2 px-1.5 border-gray-300 border-2 shadow-sm sm:text-sm pl-2"
                            >
                                <option value="">Selectează un magazin</option>
                                {warehouses.items.map((wh: any) => (
                                    <option key={wh.warehouseId} value={wh.warehouseId}>{wh.name}</option>
                                ))}
                            </select>
                        </label>
                    )}
                    
                    {(role === "BASICSUPPORT" || role === "SUPERBASIC" || role === "B2BSUPPORT" || role === "ADMIN") && (
                        <label className="flex justify-between items-center w-full">
                            <span className="text-lg font-medium text-gray-700 mt-2 mr-16">UC</span>
                            <select
                                value={uc || ""}
                                onChange={(e) => setUC(e.target.value)}
                                className="bg-gray-100 rounded py-2 px-20 border-gray-300 border-2 shadow-sm sm:text-sm pl-2"
                            >
                                {role === "ADMIN" && <>
                                    <option value="816">816</option>
                                    <option value="817">817</option>
                                </>}
                                {role === "B2BSUPPORT" && <option value="817">817</option>}
                                {(role === "BASICSUPPORT" || role === "SUPERBASIC") && <option value="816">816</option>}
                            </select>
                        </label>
                    )}
                    
                    {role === "BASIC" && (
                        <div className="mt-2">
                            <label className="flex justify-between items-center w-full">
                                <span className="text-lg font-medium text-gray-700 mt-2 mr-16">Working Point<span
                                    className="text-red-500 ml-0.5">*</span></span>
                                <select
                                    value={selectedWorkingPointId}
                                    onChange={(e) => setSelectedWorkingPointId(e.target.value)}
                                    className="bg-gray-100 rounded py-2 px-1.5 border-gray-300 border-2 shadow-sm sm:text-sm pl-2"
                                >
                                    <option value="">Selectează un punct de lucru</option>
                                    {workingPoints.map((wp) => (
                                        <option key={wp.id} value={wp.id}>{wp.workingPointName} - {wp.id}</option>
                                    ))}
                                </select>
                            </label>
                            {selectedWorkingPointId && (
                                <div className="flex flex-col mt-3">
                                    <span className="text-lg text-gray-700">
                                        Working Point ID: <span className="text-red-500">{selectedWorkingPointId}</span>
                                    </span>
                                    <span className="text-lg text-gray-700">
                                        Organizație: <span className="text-red-500">
                                          {workingPoints.find(wp => wp.id.toString() === selectedWorkingPointId)?.organization.name || "-"}
                                        </span>
                                    </span>
                                </div>
                            )}
                            {!selectedWorkingPointId && <span className="text-red-500">Selectia unui Working Point este obligatorie!</span>}
                        </div>
                    )}
                                        
                    <button
                        type="button"
                        onClick={handleSubmit}
                        disabled={(!selectedWorkingPointId && role === "BASIC") || !role}
                        className="inline-block w-full rounded-lg bg-red-500 px-4 py-2 mt-2 mb-8 font-medium text-white sm:w-auto"
                    >
                        {mode === UserFormMode.ADD ? "Creează utilizator" : "Salvează modificările"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UserFormPage;